import t from '@instructure/quiz-i18n/es/format-message';
import { BUILD_CHAR_LIMIT } from '@instructure/quiz-common';
export default (function (val, options) {
  var limit = options.limit || BUILD_CHAR_LIMIT;
  if (val && JSON.stringify(val).length > limit) {
    return t('Maximum content exceeded');
  }
});